const ResponseConstant = {
  invalid_account_error: "invalidAccountError",
  account_not_found_error: "accountNotFoundError",
  invalid_csrf_error: "invalidCsrfError",
  sms_service_unavailable_error: "smsServiceUnavailableError",
  sms_notification_failed_error: "smsNotificationFailedError",
  invalid_body_error: "invalidBodyError",
  invalid_jwt_error: "invalidJwtError",
  expired_jwt_error: "expiredJwtError",
  invalid_token_error: "invalidTokenError",
  invalid_email_error: "invalidEmailError",
  invalid_password_error: "invalidPasswordError",
  invalid_password_error_key: "invalidPasswordError",
  invalid_new_confirm_password_error: "invalidNewConfirmPasswordError",
  invalid_new_confirm_password_error_key: "invalidNewConfirmPasswordError",
  invalid_phone_number_error: "invalidPhoneNumberError",
  invalid_firstname_error: "invalidFirstnameError",
  invalid_lastname_error: "invalidLastnameError",
  invalid_job_description_error: "invalidJobDescriptionError",
  invalid_id_error: "invalidIdError",
  status_error: "invalidStatusError",
  user_already_exists_error: "userAlreadyExistsError",
  collaborator_not_found_error: "collaboratorNotFoundError",
  invalid_captcha_token_error: "invalidCaptchaTokenError",
  login_2fa_required_error: "login2faRequiredError",
  invalid_login_2fa_code_error: "invalidLogin2faCodeError",
  expired_login_2fa_code_error: "expiredLogin2faCodeError",
  login_2fa_attempt_limit_reached_error: "login2faAttemptLimitReachedError",
  login_2fa_resend_limit_reached_error: "login2faResendLimitReachedError",
  invalid_network_error: "invalidNetworkError",
  repair_center_not_found_error: "repairCenterNotFoundError",
  too_many_repair_center_found_error: "tooManyRepairCenterFoundError",
  request_draft_not_editable_error: "requestDraftNotEditableError",
  unexpected_error: "unexpectedError",
} as const;

export default ResponseConstant;
